/* istanbul ignore file */
import Layout from 'antd/lib/layout';

export default Layout;
